export default class FiltroNotasFiscais {
    constructor() {
        this.NumeroNota = undefined
        this.DataEmissaoInicio = undefined
        this.DataEmissaoTermino = undefined
        this.NumeroPedido = undefined
        this.Status = undefined
        this.ClienteId = undefined
        this.CodigoProduto = undefined
        this.NomeProduto = undefined
        this.UnidadeId = undefined
        this.ComponentesExpandidos = undefined
        this.ConsultarDadosClienteAgrupador = undefined
        this.QuebraPorProduto = undefined
        this.NumeroParcela = undefined
    }
}